export default function Obj(args = {})
{
  const inherit = (pBase, pChild) =>
  {
    pChild.prototype = object(pBase);

    for (let i in pBase)
    {
      if (pBase.hasOwnProperty(i))
      {
        pChild[i] = pBase[i];
      }
    }
  };


  this.create = (base, args1, args2) =>
  {
    let i,
        len,
        strArgums = '',
        argums = (args1 && args1.length > 0) ? args1 : (args2 && args2.length > 0) ? args2 : null,
        pBase;

    if (argums)
    {
      for (i = 0, len = argums.length; i < len; i++)
      {
        strArgums += 'argums[' + i + '],';
      }

      strArgums = strArgums.slice(0, -1);
    }

    pBase = eval('new base(' + strArgums + ')');

    if (arguments[1] && !arguments[1].length)
    {
      // O.create(BASE, CHILD, [arguments]);
      inherit(pBase, arguments[1]);

      pBase.inheritor = arguments[1];
    }
    else
    {
      // O.create(BASE, [arguments]);
      pBase.init();
    }

    return pBase;
  };


  function object(o)
  {
    function F() { }
    F.prototype = o;
    return new F();
  }
}
